import { jsml } from "../jsml.js";
import { iml } from "../iml.js";
import { retrieveComparisonIds } from "../integrateFilterCompare.js";
import { splitLines } from "./../splitLines.js";

export function methodDisplayTheDesign(request, $url = '') {

    // Get current language
    const getCurrentLanguage = () => {
        return document.getElementById('current_language').dataset.language;
    }

      //const language = getQueryString($url, 'lang')
      const language = getCurrentLanguage() || 'en';

      let renderHTML = '';
      let activeIds = [];
  
      if(!request[0]) {
          document.getElementById("filter-results").innerHTML = renderHTML;
      }
  
      request.forEach((room, i) => { 
  
          if(!room.acf) {
              return;
          }
          
          // Prepare Comparison Data Structure
          // This information will show as a dataset
          let structureComparison = JSON.stringify({ 
              'id': room.id, 
              'title' : room.title.rendered,
          });
  
          // Identify if the room is active or not, and check the checkbox on render
          let isActive = '';
          retrieveComparisonIds().forEach((id) => {
              if(room.id == id) {
                  isActive = 'checked';
              }
          });

          // is the column left or right on the page
          let rowreverse = (i % 2 == 1) ? 'flex-row-reverse' : 'flex-row';

          // Prepare Images
          let secondaryImg = '';
          let primaryImg = '';
         
          //Prepare secondary Image
          if(room.acf.featured_image_2) {
                secondaryImg = '<div class="w-50"><img class="m-res-h bg-primary div-fill-soft row-600 m-row-260 m-w-100" src="' + room.acf.featured_image_2.sizes.large + '" alt="" lazy></img></div>';
          }

         // Prepare first image, depending on if 1 or two images are displayed
          if(room.fimg_url) {
            if(room.acf.featured_image_2) {
                primaryImg += '<div class="w-50">';
            }
            if(room.fimg_url) {
                primaryImg += '<img class="m-res-h bg-primary div-fill-soft row-600 m-row-260 m-w-100" src="' + room.fimg_url + '" alt="'+ room.title.rendered +'" lazy>';
            }
            if(room.acf.featured_image_2) {
                primaryImg += '</div>';
            }
        }
           
          // Prepare the Main block for rendering
          renderHTML += `<div data-filter-id="${room.id}" class="landscape-image-text-block site-width flex justify-end gap-135 m-flex-wrap m-gap-0  m-flex-column-reverse mv-140 align-items-center ${rowreverse}" data-type="organism" data-temp="introduction-and-award-block.twig">
                          <div class="col col-420 m-w-100" data-animation="text-animation-1">
                              <div>
                                  <p class="fs-40 ff-2 i-gold">${iml(room.title.rendered)}</p>
                              </div>
                              <p>${room.excerpt.rendered.replace(/(<([^>]+)>)/gi, "").substring(0, 200)}...</p>
                              <div class="flex gap-36 m-inherit">
                                  <a class="btn" href="${room.link}">${jsml(language, 'View Space')}</a>
                              </div>
                          </div>
                          <a href="${room.link}" class="col-1055 align-self-stretch m-w-100 flex gap-36 m-mb-30" data-animation="image-animation-2">
                            ${primaryImg}
                            ${secondaryImg}
                          </a>
                      </div>`;
  
          // Push new active IDs to array
          activeIds.push(room.id);       
      });

      // Structure new HTML value with DOM Parser (Adding the new elements created to the DOM);
      let html = new DOMParser().parseFromString(renderHTML, "text/html");
      html = html.getRootNode();
      document.getElementById("filter-results").innerHTML = '';
      document.getElementById("filter-results").append(html.body);

      // Add class (Which will tell the classWatcher event to fire) when the results are loaded
      document.getElementById('filter-results').classList.add('filter-results-loaded');
}